var React = require('react');

function Share (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M11.499 19.572a5 5 0 1 1 0-7.144l9.521-5.024a4 4 0 1 1 1.4 2.653l-9.506 5.016a5.028 5.028 0 0 1 0 1.854l9.506 5.016a4 4 0 1 1-1.4 2.653L11.5 19.572z"}));
}

Share.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Share;

Share.default = Share;
